module.exports = __webpack_public_path__ + "static/media/quindio-75.9f2ca6f7.jpg";